import React, { useEffect, useRef, useState } from "react";
import UncontrolledExample from "./carousel";
import { backend, categoryurl, mediaurl, producturl } from "../../../../path";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import ScrollToTop from "../../../components/whatsapp connect";
import { Rating } from "@mui/material";
import { Helmet } from "react-helmet";
import LoaderMain from "../../../layout/header/loader_sub";
import { HiOutlineArrowLeft, HiOutlineArrowRight } from "react-icons/hi2";
import { PiShoppingCartThin } from "react-icons/pi";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styled from "styled-components";
import { CiHeart } from "react-icons/ci";
import { VscHeartFilled } from "react-icons/vsc";
import { RxPadding } from "react-icons/rx";
import StarIcon from "@mui/icons-material/Star";
import { trimDescriptionToTen } from "../../../../utils/trimDescription";
import TopSellingComponent from "../../topselling/Index";
import HeroSlider from "./HeroSlider";
import ProductSlider from "../../../components/slider/PopularSlider";
import PopularSliderMobile from "../../../components/slider/PopularSliderMobile";
import ProductCard from "../../../components/ProductCard/ProductCard";

function HomepageNew(props) {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [catData, setCatData] = useState([]);

  const [loading, setLoading] = useState();
  const [error, setError] = useState();
  const [subEmail, setSubEmail] = useState("");

  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );

  const [value, setValue] = React.useState(2);
  const [hover, setHover] = React.useState(-1);
  const [currentSlide, setCurrentSlide] = useState(0);
  const slidesToShow = 4; // Adjust based on your responsive needs

  const handleNextPop = () => {
    setCurrentSlide((prev) =>
      Math.min(prev + 1, data.getPopularProduct.length - slidesToShow)
    );
  };

  const handlePrevPop = () => {
    setCurrentSlide((prev) => Math.max(prev - 1, 0));
  };
  const desktopSliderRef = useRef(null);
  const mobileSliderRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    fade: true,
    waitForAnimate: false,
  };
  const Topsellingsettings = {
    dots: false,
    infinite: data?.getTopSelling?.length > 6,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    rows: 1,
    slidesPerRow: 1,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 2,
          rows: 1,
          slidesPerRow: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          rows: 1,
          slidesPerRow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 2,
          rows: 1,
          slidesPerRow: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          rows: 1,
          slidesPerRow: 1,
        },
      },
    ],
  };
  const Topsettings = {
    dots: false,
    infinite: data?.getDealOfTheDay?.length > 4,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    rows: 1,
    slidesPerRow: 1,
    className: "slider variable-width",
    centerMode: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          rows: 1,
          slidesPerRow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
          rows: 1,
          slidesPerRow: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 1,
          slidesPerRow: 1,
        },
      },
    ],
  };
  const handlePrev = () => {
    const ref = isMobile ? mobileSliderRef : desktopSliderRef;
    if (ref.current) ref.current.slickPrev();
  };

  const handleNext = () => {
    const ref = isMobile ? mobileSliderRef : desktopSliderRef;
    if (ref.current) ref.current.slickNext();
  };
  // useEffect(()=>{
  //   let userdata = JSON.parse(localStorage.getItem('userdata'));
  //   fetch(backend + "tokentest", {
  //     method: "POST",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization:`Bearer ${userdata.access_token}`,
  //       "Content-Type": "application/json",
  //     }
  //   })
  //     .then((response) => {
  //       response.json().then((data) => {
  //       console.log(data)

  //       });
  //     })
  //     .catch((error) => {
  //       console.error("Error during login:", error);
  //     });
  // },[])


  const fetchData = () => {
    setLoading(true);

    fetch(backend + "getallspecialproduts", {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchDataCat = () => {
    // Assuming setData, setError, and setLoading are state functions from useState
    setLoading(true);

    fetch(backend + "getcategorywithsubcategory", {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setCatData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    // Scroll to the top of the page whenever a new page is rendered
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetchData();
    fetchDataCat();
  }, []);

  const handleAddCart = async (id) => {
    if (authenticated === null) {
      if (typeof window.openAuthModal === "function") {
        window.openAuthModal("login");
      } else {
        navigate("/login");
      }
      return;
    }

    const formData = {
      status: 1,
      quantity: 1,
      product_id: id,
    };

    try {
      const response = await fetch(backend + "addtocartuserside", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        toast.success("Item added to cart", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        props.setCartChange(!props.cartChange);
        await new Promise((resolve) => setTimeout(resolve, 3000));
        // navigate("/cart");
      } else if (response.status === 409) {
        toast.error("Conflict occurred. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (response.status === 401) {
        toast.error("Item already exits in the cart", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Something went wrong. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again later.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleProductRoute = (productId) => {
    navigate(`/product/${productId}`);
    // window.location.reload();
  };
  const handleAddToWishList = async (id) => {
    if (authenticated === null) {
      if (typeof window.openAuthModal === "function") {
        window.openAuthModal("login");
      } else {
        navigate("/login");
      }
      return;
    }

    const formData = {
      status: 0,
      product_id: id,
    };

    try {
      const response = await fetch(backend + "addtowishlistuserside", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        toast.success("Item added to wishlist", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        props.setWishChange(!props.wishChange);
        await new Promise((resolve) => setTimeout(resolve, 3000));
        // navigate("/cart");
      } else if (response.status === 409) {
        toast.error("Conflict occurred. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (response.status === 401) {
        toast.error("Item already exits in the wishlist", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Something went wrong. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again later.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleSubscribe = (e) => {
    e.preventDefault();
    fetch(backend + "addsubscription", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: subEmail }),
    })
      .then((response) => {
        setSubEmail("");
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );

          // Check for conflict status (HTTP 409)
          if (response.status === 409) {
            console.error("Email Already Exists");
            toast.error("Email Already Exists", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            console.error("Registration failed");
            toast.error("Registration failed", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          return;
        }

        response.json().then(() => {
          toast.success("Subscribed Successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
      })
      .catch((error) => {
        console.error("Error during registration:", error);
        toast.error("Registration failed", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };
  const heroImages = [
    {
      id: 1,
      src: "/storage/general/ks_banner_crafts.png",
      mob_src: "/storage/general/ks_banner_crafts.png",
      route: "/category/art-crafts",
      bgColor: "#682c18",
      tagline: "HERITAGE OF MALABAR",
      title: "Handcrafted Heritage. Timeless Artistry.",
      desc: "Sustainably sourced brassware, organic teak wood, and intricate rosewood handicrafts crafted by Kerala’s master artisans."
    },
    {
      id: 2,
      src: "/storage/general/ks_banner_spices.png",
      mob_src: "/storage/general/ks_banner_spices.png",
      route: "/subcategory/kerala-special-spices",
      bgColor: "#123524",
      tagline: "THE ESSENCE OF PURITY",
      title: "Single-Origin. Untouched Purity.",
      desc: "Handpicked premium green cardamom, rich black pepper, and organic herbs harvested straight from Kerala’s spice valleys."
    },
    {
      id: 3,
      src: "/storage/general/ks_banner_snacks.png",
      mob_src: "/storage/general/ks_banner_snacks.png",
      route: "/subcategory/kerala-special-snacks",
      bgColor: "#a89206",
      tagline: "TRADITIONAL DELIGHTS",
      title: "Crispy. Fresh. Indulgent.",
      desc: "Traditional golden banana chips fried in pure coconut oil and authentic snacks prepared using time-honored recipes."
    },
  ];
  function getFirstImageUrl(data) {
    const producturl = "https://keralaspecial.in/server/public/upload/products";

    // Check if data is a valid string
    if (typeof data !== "string" || !data.trim()) {
      console.error("Invalid data provided:", data);
      return null; // Return null or an appropriate default value
    }

    try {
      // Use a regular expression to extract all strings inside double quotes
      let matches = data
        .match(/"([^"]*)"/g)
        ?.map((item) => item.replace(/"/g, ""));

      // Check if matches exist and get the first value
      if (matches && matches.length > 0) {
        let firstImage = matches[0];
        // Join the base URL with the first image filename
        return `${producturl}/${firstImage}`;
      } else {
        console.error("No matches found in data:", data);
        return null;
      }
    } catch (error) {
      console.error("Error processing data:", error);
      return null;
    }
  }
  const scrollDown = () => {
    //function to scroll down 100px
    window.scrollBy(0, 1000);
  };
  function trimText(text, maxLength = 35) {
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  }
  const handleAyurvedha = () => {
    navigate("/category/ayurveda");
  };
  const handleProduct = () => {
    navigate("/category/handlooms");
  };
  const handleCategoryMain = (cat) => {
    // sessionStorage.setItem("categoryId", cat);
    // setSubcategory(false)
    // props?.SearchFetch();
    navigate(`/category/${cat}`);
    // window.location.reload();
  };
  const [isWideScreen, setIsWideScreen] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth > 1400);
      setIsSmallScreen(window.innerWidth < 1025);
    };

    // Initial check
    handleResize();

    // Listen for screen resize
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, [window.innerWidth]);

  const getPriceNum = (price) => {
    if (!price) return 0;
    return parseFloat(price.toString().replace(/[^\d.]/g, "")) || 0;
  };

  const allDeals = data?.getDealOfTheDay || [];
  const hasExpensiveDeals = allDeals.some(
    (item) => getPriceNum(item?.sale_price) >= 3000
  );

  let filteredDeals = [];
  let filteredDealsLeft = [];

  if (hasExpensiveDeals) {
    filteredDeals = allDeals.filter(
      (item) => getPriceNum(item?.sale_price) >= 3000
    );
    filteredDealsLeft = allDeals.filter(
      (item) => getPriceNum(item?.sale_price) < 3000
    );
  } else {
    // Graceful fallback: split deals so both columns are beautifully populated
    filteredDeals = allDeals.slice(0, 2);
    filteredDealsLeft = allDeals.slice(2);
  }

  const dealsToRender = isWideScreen
    ? filteredDeals
    : isSmallScreen
      ? filteredDeals?.slice(0, 3)
      : filteredDeals?.slice(0, 2);

  const dealsToRenderLeft = isWideScreen
    ? filteredDealsLeft?.slice(0, 7)
    : filteredDealsLeft?.slice(0, 5);


  const catDataLocal = [
    {
      category_id: 1,
      category_name: "Handlooms",
      category_slug: "/category/handlooms",
      logo: "/storage/category/Frame 158.png",
    },
    {
      category_id: 2,
      category_name: "Herbals",
      category_slug: "/subcategory/diabetes-care",
      logo: "/storage/category/Frame 159.png",
    },
    {
      category_id: 3,
      category_name: "Savory & Crispy",
      category_slug: "/subcategory/kerala-special-snacks",
      logo: "/storage/category/Frame 160.png",
    },
    {
      category_id: 4,
      category_name: "Spices & Aromatics",
      category_slug: "/subcategory/kerala-special-spices",
      logo: "/storage/category/Frame 161.png",
    },
    {
      category_id: 5,
      category_name: "Kerala Heritage Decor",
      category_slug: "",
      logo: "/storage/category/Frame 162.png",
    }
  ]
  return (
    <>
      {loading && <LoaderMain />}

      <Helmet>
        <title>Best online products in kerala</title>
        <meta
          name="description"
          content="Discover Kerala's finest products online! Handicrafts, spices, Ayurveda, handlooms & more. Fast & reliable shipping."
        />
        <meta
          name="keywords"
          content="online shopping,online shopping sites,online store"
        />
      </Helmet>
      <main>
        {/* ----------------------------------------------------- */}
        {/* Hero section start */}
        <Hero>
          <div className="slider-container">
            <HeroSlider heroImages={heroImages} />
          </div>
        </Hero>
        {/* Hero section end */}
        {/* ----------------------------------------------------- */}
        {/* Experience section start */}
        {/* Trust & Brand Experience Pillars Section */}
        <section className="bg-kerala-sand py-16 border-y border-kerala-gold/15">
          <div className="mx-auto sm:px-6 max-w-7xl">
            <div className="text-center max-w-2xl mx-auto mb-12">
              <span className="text-kerala-gold font-jost text-sm font-semibold tracking-widest uppercase">Traditional. Pure. Original.</span>
              <h2 className="text-kerala-green font-playfair text-3xl sm:text-4xl mt-2 font-bold">Why Kerala Special?</h2>
              <div className="h-0.5 w-16 bg-kerala-gold mx-auto mt-4"></div>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="flex flex-col items-center text-center p-6 bg-kerala-ivory rounded-2xl shadow-[0_4px_20px_rgba(45,31,24,0.02)] border border-kerala-gold/10 hover:-translate-y-2 hover:border-kerala-gold/35 hover:shadow-[0_12px_40px_rgba(197,168,128,0.12)] transition-all duration-500 ease-out group">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-kerala-green/10 mb-4 transition-transform duration-500 group-hover:scale-110">
                  <img src="/storage/general/hugeicons_truck-delivery.svg" alt="delivery" className="w-6 h-6 text-kerala-green" />
                </div>
                <h4 className="text-kerala-green font-jost font-semibold text-lg">Express Home Delivery</h4>
                <p className="text-kerala-bark/80 font-poppins text-xs mt-2 leading-relaxed">Fast, secure shipping straight from the heart of Kerala to your doorstep.</p>
              </div>

              <div className="flex flex-col items-center text-center p-6 bg-kerala-ivory rounded-2xl shadow-[0_4px_20px_rgba(45,31,24,0.02)] border border-kerala-gold/10 hover:-translate-y-2 hover:border-kerala-gold/35 hover:shadow-[0_12px_40px_rgba(197,168,128,0.12)] transition-all duration-500 ease-out group">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-kerala-green/10 mb-4 transition-transform duration-500 group-hover:scale-110">
                  <img src="/storage/general/8+.svg" alt="experience" className="w-6 h-6" />
                </div>
                <h4 className="text-kerala-green font-jost font-semibold text-lg">8+ Years of Heritage</h4>
                <p className="text-kerala-bark/80 font-poppins text-xs mt-2 leading-relaxed">A trusted bridge of authenticity, serving thousands of satisfied premium consumers.</p>
              </div>

              <div className="flex flex-col items-center text-center p-6 bg-kerala-ivory rounded-2xl shadow-[0_4px_20px_rgba(45,31,24,0.02)] border border-kerala-gold/10 hover:-translate-y-2 hover:border-kerala-gold/35 hover:shadow-[0_12px_40px_rgba(197,168,128,0.12)] transition-all duration-500 ease-out group">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-kerala-green/10 mb-4 transition-transform duration-500 group-hover:scale-110">
                  <img src="/storage/general/Group.svg" alt="artisans" className="w-6 h-6" />
                </div>
                <h4 className="text-kerala-green font-jost font-semibold text-lg">Handcrafted Premium Value</h4>
                <p className="text-kerala-bark/80 font-poppins text-xs mt-2 leading-relaxed">Direct-from-source pricing, empowering weavers and sustainable farmers.</p>
              </div>

              <div className="flex flex-col items-center text-center p-6 bg-kerala-ivory rounded-2xl shadow-[0_4px_20px_rgba(45,31,24,0.02)] border border-kerala-gold/10 hover:-translate-y-2 hover:border-kerala-gold/35 hover:shadow-[0_12px_40px_rgba(197,168,128,0.12)] transition-all duration-500 ease-out group">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-kerala-green/10 mb-4 transition-transform duration-500 group-hover:scale-110">
                  <img src="/storage/general/cil_happy.svg" alt="purity" className="w-6 h-6" />
                </div>
                <h4 className="text-kerala-green font-jost font-semibold text-lg">100% Guaranteed Purity</h4>
                <p className="text-kerala-bark/80 font-poppins text-xs mt-2 leading-relaxed">Every spice, handloom, and craft is handpicked, quality assured.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Cinematic Heritage Brand Storytelling Section */}
        <section className="py-20 bg-kerala-ivory overflow-hidden">
          <div className="mx-auto sm:px-6 max-w-7xl">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
              <div className="lg:col-span-5 flex flex-col justify-center">
                <span className="text-kerala-gold font-jost text-sm font-semibold tracking-widest uppercase">Preserving Legacy</span>
                <h2 className="text-kerala-green font-playfair text-4xl sm:text-5xl mt-3 mb-6 font-bold leading-tight">Handcrafted with Love, Rooted in Tradition</h2>
                <p className="text-kerala-bark/90 font-jost text-base mb-6 leading-relaxed">
                  KeralaSpecial is born from the whispers of coconut palms, the aroma of fresh rain on cardamom plantations, and the meticulous rhythm of handloom shuttles. We bring you the uncompromised purity of Kerala's heritage, direct from local families and authentic master weavers.
                </p>
                <p className="text-kerala-bark/80 font-jost text-sm mb-8 italic">
                  "Every purchase directly sustains local artisans, single-origin farmers, and Ayurvedic practitioners who preserve Kerala's natural treasures."
                </p>
                <div>
                  <button 
                    onClick={() => navigate("/category/handlooms")}
                    className="inline-flex items-center gap-3 bg-kerala-green text-kerala-ivory font-jost px-8 py-3.5 rounded-full font-medium tracking-wide shadow-md hover:bg-kerala-gold hover:shadow-lg transition-all duration-300"
                  >
                    <span>Experience Kerala at Home</span>
                    <HiOutlineArrowRight size={18} />
                  </button>
                </div>
              </div>

              <div className="lg:col-span-7 relative">
                <div className="grid grid-cols-12 gap-4 items-center">
                  <div className="col-span-6 space-y-4">
                    <div className="relative overflow-hidden rounded-2xl border border-kerala-gold/15 shadow-[0_4px_20px_rgba(0,0,0,0.02)] transition-all duration-500 ease-out hover:border-kerala-gold/45 hover:shadow-[0_12px_30px_rgba(197,168,128,0.1)] group">
                      <img src="/storage/category/Frame 158.png" alt="Traditional Weave" className="w-full h-[220px] object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                    </div>
                    <div className="relative overflow-hidden rounded-2xl border border-kerala-gold/15 shadow-[0_4px_20px_rgba(0,0,0,0.02)] transition-all duration-500 ease-out hover:border-kerala-gold/45 hover:shadow-[0_12px_30px_rgba(197,168,128,0.1)] group">
                      <img src="/storage/category/Frame 161.png" alt="Spice Harvest" className="w-full h-[180px] object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                    </div>
                  </div>
                  <div className="col-span-6 space-y-4 pt-12">
                    <div className="relative overflow-hidden rounded-2xl border border-kerala-gold/15 shadow-[0_4px_20px_rgba(0,0,0,0.02)] transition-all duration-500 ease-out hover:border-kerala-gold/45 hover:shadow-[0_12px_30px_rgba(197,168,128,0.1)] group">
                      <img src="/storage/category/Frame 159.png" alt="Ayurveda Heritage" className="w-full h-[180px] object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                    </div>
                    <div className="relative overflow-hidden rounded-2xl border border-kerala-gold/15 shadow-[0_4px_20px_rgba(0,0,0,0.02)] transition-all duration-500 ease-out hover:border-kerala-gold/45 hover:shadow-[0_12px_30px_rgba(197,168,128,0.1)] group">
                      <img src="/storage/category/Frame 160.png" alt="Culinary Delights" className="w-full h-[220px] object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Experience section end */}
        {/* ----------------------------------------------------- */}

        {/* Categories List Sectio */}
        <section className="wrapper">
          <div className="mx-auto sm:px-6 max-w-7xl">
            <div
              className="
        flex overflow-x-auto gap-4 mt-6 pb-4
        sm:grid sm:grid-cols-5 sm:gap-3 sm:pb-0 sm:mt-10
        lg:mt-16 lg:gap-4 lg:grid-cols-5
        scrollbar-none snap-x snap-mandatory
      "
              style={{
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              {catDataLocal &&
                catDataLocal.slice(0, 5).map((item) => (
                  <div
                    key={item.category_id}
                    className="relative group flex flex-col items-center flex-shrink-0 snap-start w-[85px] sm:w-auto"
                    onClick={() => {
                      navigate(item.category_slug);
                    }}
                  >
                    <div
                      className="
                w-[70px] h-[70px] 
                sm:w-[130px] sm:h-[130px] 
                lg:w-[170px] lg:h-[170px]
                overflow-hidden rounded-full border-2 p-1.5 transition-all duration-500 ease-out
                group-hover:border-kerala-gold group-hover:scale-105 group-hover:shadow-[0_8px_24px_rgba(197,168,128,0.2)]
              "
                      style={{
                        borderColor: "rgba(197, 168, 128, 0.15)",
                        background: "linear-gradient(135deg, #FDFBF7 0%, #F2ECE1 100%)",
                      }}
                    >
                      <img
                        className="w-full h-full object-cover rounded-full transition-all duration-500 ease-out"
                        src={item.logo}
                        alt={item.category_name}
                      />
                    </div>
                    <div className="mt-3 lg:mt-4">
                      <div className="flex justify-center">
                        <h3
                          className="text-[11px] sm:text-[14px] lg:text-[16px] font-medium text-kerala-bark leading-none font-jost tracking-wide max-w-[240px] truncate text-center transition-colors duration-300 group-hover:text-kerala-gold"
                          title={item?.category_name}
                        >
                          <span className="cursor-pointer">{item?.category_name}</span>
                        </h3>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </section>

        {/* Deals section start */}
        <section className="wrapper bg-white pt-4 pb-0 sm:pt-12 sm:pb-8">
          <div className="mx-auto sm:px-6 max-w-7xl">
            {/* Unified, highly premium text-based section header */}
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end mb-8 pb-4 border-b border-kerala-gold/15 gap-4">
              <div className="flex flex-col gap-1 text-left">
                <span className="text-[#C5A880] font-jost text-xs font-semibold tracking-widest uppercase">Limited Time Offers</span>
                <h2 className="text-[#123524] font-playfair text-3xl sm:text-4xl font-bold">Today's Deals</h2>
              </div>
              <div className="text-right">
                <Link to="/deals" className="text-[#C5A880] hover:text-[#123524] font-jost text-sm font-semibold transition-colors duration-300 flex items-center gap-1">
                  <span>View All Deals</span>
                  <span>→</span>
                </Link>
              </div>
            </div>

            <Deals>
              <Left className="deals-left">
                {/* Static full-cover image card */}
                {/* Glassmorphic Deals Intro Panel (Pure React-based, no flat images!) */}
                <DealsIntroCard 
                  key="static-image-card" 
                  onClick={() => navigate("/deals")}
                  className="rounded-[23px] p-8 flex flex-col justify-between text-left cursor-pointer border border-[#C5A880]/20 relative overflow-hidden"
                  style={{
                    background: "linear-gradient(135deg, #123524 0%, #0d261a 100%)",
                    height: "100%",
                    minHeight: "410px"
                  }}
                >
                  {/* Ambient light glow layers */}
                  <div className="absolute -right-20 -top-20 w-48 h-48 rounded-full bg-[#C5A880]/15 filter blur-3xl pointer-events-none" />
                  <div className="absolute -left-20 -bottom-20 w-48 h-48 rounded-full bg-[#123524]/40 filter blur-3xl pointer-events-none" />
                  
                  <div className="relative z-10 flex flex-col gap-4 mt-4">
                    <span className="text-[#C5A880] font-jost text-xs font-semibold tracking-widest uppercase">Limited Time Offers</span>
                    <h3 className="text-white font-playfair text-3xl font-bold leading-tight">Deals of the Day</h3>
                    <p className="text-white/80 font-jost text-sm leading-relaxed mt-2">
                      Don't wait—grab today's premium handcrafted treasures and single-origin spices before they are gone!
                    </p>
                  </div>
                  
                  <div className="relative z-10 mb-4">
                    <button className="inline-flex items-center gap-2 bg-[#f7ca00] text-[#111111] hover:bg-[#f5b700] transition-colors font-jost text-xs font-semibold uppercase tracking-wider px-6 py-3 rounded-full shadow-md">
                      <span>View All Deals</span>
                      <span>→</span>
                    </button>
                  </div>
                </DealsIntroCard>

                {/* Then render the API deals */}
                {data &&
                  data.getDealOfTheDay &&
                  dealsToRenderLeft.map((item, index) => (
                    <ProductCard
                      key={item.product_id}
                      item={item}
                      producturl={producturl}
                      handleProductRoute={handleProductRoute}
                      handleAddToWishList={handleAddToWishList}
                      handleAddCart={handleAddCart}
                    />
                  ))}
              </Left>

              <Right>
                {data &&
                  data.getDealOfTheDay &&
                  dealsToRender.map((item, index) => (
                    <ProductCard
                      key={item.product_id}
                      item={item}
                      producturl={producturl}
                      handleProductRoute={handleProductRoute}
                      handleAddToWishList={handleAddToWishList}
                      handleAddCart={handleAddCart}
                    />
                  ))}
              </Right>
            </Deals>

            <MobileDeals>
              <div className="mb-6">
                <DealsIntroCard 
                  onClick={() => navigate("/deals")}
                  className="rounded-[23px] p-6 flex flex-col justify-between text-left cursor-pointer border border-[#C5A880]/20 relative overflow-hidden"
                  style={{
                    background: "linear-gradient(135deg, #123524 0%, #0d261a 100%)",
                    minHeight: "260px"
                  }}
                >
                  {/* Ambient light glow layers */}
                  <div className="absolute -right-20 -top-20 w-32 h-32 rounded-full bg-[#C5A880]/15 filter blur-2xl pointer-events-none" />
                  <div className="absolute -left-20 -bottom-20 w-32 h-32 rounded-full bg-[#123524]/40 filter blur-3xl pointer-events-none" />
                  
                  <div className="relative z-10 flex flex-col gap-2 mt-2">
                    <span className="text-[#C5A880] font-jost text-xs font-semibold tracking-widest uppercase">Limited Time Offers</span>
                    <h3 className="text-white font-playfair text-2xl font-bold leading-tight">Deals of the Day</h3>
                    <p className="text-white/80 font-jost text-xs leading-relaxed mt-1">
                      Don't wait—grab today's premium handcrafted treasures and spices before they are gone!
                    </p>
                  </div>
                  
                  <div className="relative z-10 mb-2 mt-4">
                    <button className="inline-flex items-center gap-2 bg-[#f7ca00] text-[#111111] hover:bg-[#f5b700] transition-colors font-jost text-[10px] font-semibold uppercase tracking-wider px-5 py-2.5 rounded-full shadow-md">
                      <span>View All Deals</span>
                      <span>→</span>
                    </button>
                  </div>
                </DealsIntroCard>
              </div>

              <div className="slider-container x">
                {data?.getDealOfTheDay?.length > 0 && (
                  <Slider {...Topsettings}>
                    {data.getDealOfTheDay.map((item, index) => {
                      return (
                        <div key={item.product_id} style={{ padding: "0 10px" }}>
                          <ProductCard
                            item={item}
                            producturl={producturl}
                            handleProductRoute={handleProductRoute}
                            handleAddToWishList={handleAddToWishList}
                            handleAddCart={handleAddCart}
                          />
                        </div>
                      );
                    })}
                  </Slider>
                )}
              </div>
            </MobileDeals>
          </div>
        </section>
        {/* Deals section end */}
        {/* ----------------------------------------------------- */}
        {/* Popular section start */}

        {/* <section class="py-12 bg-white sm:py-16 lg:py-20 wrapper">
          <div className="grid grid-cols-2">
            <div className="mx-auto">
              <img src="/storage/general/Frame 147.svg" alt="popular" />
            </div>
            <div class="mx-auto sm:px-6 max-w-7xl">
              <div class="grid grid-cols-2 gap-3 mt-10 lg:mt-16 lg:gap-4 lg:grid-cols-4 xl:grid-cols-5 xl:gap-5">
                {data.getPopularProduct &&
                  data.getPopularProduct.slice(0, 5).map((item) => (
                    <div
                      key={item.product_id}
                      class="relative group  justify-items-center"
                    >
                      <div
                        className="w-[255px] h-[255px] overflow-hidden rounded-[23px] border"
                        style={{ borderColor: "rgba(237, 237, 237, 1)" }}
                      >
                        <img
                          className="w-full h-full object-cover transition-all duration-300 group-hover:scale-125"
                          src={producturl + item.thumbnail}
                          alt={item.product_name}
                        />
                      </div>

                      <div class="absolute left-3 top-3">
                        <p class="sm:px-3 sm:py-1.5 px-1.5 py-1 text-[8px] sm:text-xs font-bold tracking-wide text-gray-900 uppercase bg-white rounded-full">
                          <RatingBox>
                            <span style={{ fontSize: "14px", color: "#fff" }}>
                              {Number(item?.average_stars) || 4}
                            </span>
                            <StarIcon
                              style={{ fontSize: "14px", color: "#fff" }}
                            />
                          </RatingBox>
                        </p>
                      </div>
                      <div className="mt-4 mx-3">
                        <div>
                          <h3
                            className="text-[15px] font-medium text-gray-900 leading-[100%] font-[Poppins] max-w-[240px] truncate"
                            title={item?.product_name}
                          >
                            <a href="#">
                              {item?.product_name}
                              <span
                                className="absolute inset-0"
                                aria-hidden="true"
                              ></span>
                            </a>
                          </h3>
                        </div>
                      </div>

                      <div className=" mt-4 space-x-4">
                        <div></div>

                        <div className="text-left">
                          <p className="text-[24px] font-medium text-gray-900 leading-[100%] font-[Poppins] color-rgba(0, 0, 0, 1)">
                            ₹{item?.sale_price}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </section> */}
        <section className="hidden lg:block pt-6 bg-white sm:pt-8 lg:pt-6 wrapper">
          <div className="mx-auto sm:px-6 max-w-7xl">
            <div className="grid grid-cols-[255px_1fr] gap-6 items-stretch">
              {/* Left Column – Dynamic Premium React Card (No flat images!) */}
              <div className="h-full">
                <DealsIntroCard 
                  onClick={() => navigate("/popular")}
                  className="rounded-[23px] p-8 flex flex-col justify-between text-left cursor-pointer border border-[#C5A880]/20 relative overflow-hidden"
                  style={{
                    background: "linear-gradient(135deg, #123524 0%, #0d261a 100%)",
                    height: "100%",
                    minHeight: "410px"
                  }}
                >
                  {/* Ambient light glow layers */}
                  <div className="absolute -right-20 -top-20 w-48 h-48 rounded-full bg-[#C5A880]/15 filter blur-3xl pointer-events-none" />
                  <div className="absolute -left-20 -bottom-20 w-48 h-48 rounded-full bg-[#123524]/40 filter blur-3xl pointer-events-none" />
                  
                  <div className="relative z-10 flex flex-col gap-4 mt-4">
                    <span className="text-[#C5A880] font-jost text-xs font-semibold tracking-widest uppercase">Best in Top</span>
                    <h3 className="text-white font-playfair text-3xl font-bold leading-tight">Popular Products</h3>
                    <p className="text-white/80 font-jost text-sm leading-relaxed mt-2">
                      Explore the most loved traditional treasures, authentic handlooms, and single-origin wellness essentials.
                    </p>
                  </div>
                  
                  <div className="relative z-10 mb-4">
                    <button className="inline-flex items-center gap-2 bg-[#f7ca00] text-[#111111] hover:bg-[#f5b700] transition-colors font-jost text-xs font-semibold uppercase tracking-wider px-6 py-3 rounded-full shadow-md">
                      <span>View All</span>
                      <span>→</span>
                    </button>
                  </div>
                </DealsIntroCard>
              </div>
              {/* Right Column – Wider */}
              <div className="w-full relative overflow-hidden min-w-0">
                <ProductSlider
                  data={data}
                  producturl={producturl}
                  handleProductRoute={handleProductRoute}
                  handleAddToWishList={handleAddToWishList}
                  handleAddCart={handleAddCart}
                />
              </div>{" "}
            </div>
          </div>
        </section>
        <section className="block lg:hidden pt-0 pb-1 bg-white wrapper">
          <div className="mx-auto sm:px-6 max-w-7xl">
            <div className="flex justify-between items-center mb-3">
              <div className="flex flex-col gap-1 text-left">
                <span className="text-[#C5A880] font-jost text-xs font-semibold tracking-widest uppercase">Best in Top</span>
                <h2 className="text-[#123524] font-playfair text-2xl font-bold">Popular Products</h2>
              </div>
              <button 
                onClick={() => navigate("/popular")}
                className="inline-flex items-center gap-1.5 bg-[#123524] text-white font-jost text-xs font-medium px-5 py-2.5 rounded-full hover:bg-[#C5A880] transition-colors duration-300 shadow-sm"
              >
                <span>View All</span>
                <span>→</span>
              </button>
            </div>

            <div className="relative overflow-hidden min-w-0 w-full">
              <PopularSliderMobile
                data={data}
                producturl={producturl}
                handleProductRoute={handleProductRoute}
                handleAddToWishList={handleAddToWishList}
                handleAddCart={handleAddCart}
              />
            </div>
          </div>
        </section>

        {/* Experience section end */}
        {/* ----------------------------------------------------- */}
        {/* ----------------------------------------------------- */}
        {/* Unveiling section start */}
        <section className="wrapper hidden md:block">
          <div className="mx-auto sm:px-6 max-w-7xl">
            <Unveiling>
              <ImageContainer className="unveiling-banner ">
                <img src="/storage/general/banner1-2.png" alt="Image not found" />
              </ImageContainer>
              <div className="wrapper">
                <ContainerFull className="unveiling">
                  <Left className="unveiling">
                    <span className="badge">Daily Ayurveda Spotlight</span>
                    <h3>Unveiling Ayurvedic Delights for the Day </h3>
                    <p className="subcopy">
                      Discover the essence of holistic wellness with our curated
                      selection of Ayurvedic treasures. From rejuvenating skin
                      care to nourishing herbal supplements, embark on a journey
                      of self-care and vitality.
                    </p>
                    <ul className="benefits">
                      <li>Curated rituals for balanced living</li>
                      <li>Authentic craftsmanship from Kerala</li>
                      <li>Freshly packed and delivered nationwide</li>
                    </ul>
                    <div className="cta-group">
                      <button onClick={handleAyurvedha}>
                        <span>Shop Now</span>
                        <span>
                          <HiOutlineArrowRight />
                        </span>
                      </button>
                      <button type="button" className="secondary" onClick={handleAyurvedha}>
                        Explore Ayurvedic Range
                      </button>
                    </div>
                  </Left>
                  <RightUnviel className="unveiling">
                    <div className="visual-card">
                      <div className="visual-glow" />
                      <ImageContainer className="unveiling">
                        <img
                          src="/storage/general/banner1-3.png"
                          alt="Image not found"
                        />
                      </ImageContainer>
                      <div className="visual-card__badge">Pure &amp; Potent</div>
                      <div className="visual-card__note">
                        <span>Hand-picked herbs, freshly crafted</span>
                        <span>Elevate your daily wellness ritual</span>
                      </div>
                    </div>
                  </RightUnviel>
                </ContainerFull>
              </div>
            </Unveiling>
          </div>
        </section>

        {/* Unveiling section end */}
        {/* ----------------------------------------------------- */}
        {/* ----------------------------------------------------- */}
        {/* Top Selling section start */}
        <TopSelling>
          <div className="mx-auto sm:px-6 max-w-7xl hidden md:block">
            <h2>
              <ButtonContainer>
                <img src="/storage/general/Top Selling.svg" alt="top selling" onClick={() => navigate("/top-selling")} className="cursor-pointer" />
                <div className="flex items-center gap-2">
                  <TopSellingButton onClick={handlePrev}>
                    <HiOutlineArrowLeft />
                  </TopSellingButton>
                  <TopSellingButton onClick={handleNext}>
                    <HiOutlineArrowRight />
                  </TopSellingButton>
                </div>
              </ButtonContainer>
            </h2>
            <div className="slider-container x">
              {data?.getTopSelling?.length > 0 && (
                <Slider ref={desktopSliderRef} {...Topsellingsettings}>
                  {data.getTopSelling.map((item, index) => {
                    return (
                      <div key={item.product_id} style={{ padding: "0 10px 20px" }}>
                        <ProductCard
                          item={item}
                          producturl={producturl}
                          handleProductRoute={handleProductRoute}
                          handleAddToWishList={handleAddToWishList}
                          handleAddCart={handleAddCart}
                        />
                      </div>
                    );
                  })}
                </Slider>
              )}
            </div>
          </div>
          <div
            className="p-4 mx-auto sm:px-6 max-w-7xl rounded-[27px] block md:hidden"
            style={{
              background:
                "linear-gradient(180deg, rgba(250, 152, 1, 0.64) 0%, rgba(255, 236, 208, 0.64) 100%)",
            }}
          >
            {" "}
            <h2>
              <ButtonContainer>
                <img
                  src="/storage/general/Top Selling Mobile.svg"
                  alt="top selling"
                />
                <div className="flex items-center gap-2">
                  <TopSellingButton onClick={handlePrev}>
                    <HiOutlineArrowLeft />
                  </TopSellingButton>
                  <TopSellingButton onClick={handleNext}>
                    <HiOutlineArrowRight />
                  </TopSellingButton>
                </div>
              </ButtonContainer>
            </h2>
            <div className="slider-container x">
              {data?.getTopSelling?.length > 0 && (
                <Slider ref={mobileSliderRef} {...Topsellingsettings}>
                  {data.getTopSelling.map((item, index) => {
                    return (
                      <div key={item.product_id} style={{ padding: "0 10px" }}>
                        <ProductCard
                          item={item}
                          producturl={producturl}
                          handleProductRoute={handleProductRoute}
                          handleAddToWishList={handleAddToWishList}
                          handleAddCart={handleAddCart}
                        />
                      </div>
                    );
                  })}
                </Slider>
              )}
            </div>
          </div>
        </TopSelling>
        {/* Top Selling section end */}
        {/* ----------------------------------------------------- */}

        {/* unveiling small screen */}

        <section className="wrapper block md:hidden">
          <div className="mx-auto sm:px-6 max-w-7xl">
            <Unveiling>
              <ImageContainer className="unveiling-banner ">
                <img src="/storage/general/banner1-2.png" alt="Image not found" />
              </ImageContainer>
              <div className="wrapper">
                <ContainerFull className="unveiling">
                  <Left className="unveiling">
                    <span className="badge">Daily Ayurveda Spotlight</span>
                    <h3>Unveiling Ayurvedic Delights for the Day </h3>
                    <p className="subcopy">
                      Discover the essence of holistic wellness with our curated
                      selection of Ayurvedic treasures. From rejuvenating skin
                      care to nourishing herbal supplements, embark on a journey
                      of self-care and vitality.
                    </p>
                    <ul className="benefits">
                      <li>Curated rituals for balanced living</li>
                      <li>Authentic craftsmanship from Kerala</li>
                      <li>Freshly packed and delivered nationwide</li>
                    </ul>
                    <div className="cta-group">
                      <button onClick={handleAyurvedha}>
                        <span>Shop Now</span>
                        <span>
                          <HiOutlineArrowRight />
                        </span>
                      </button>
                      <button type="button" className="secondary" onClick={handleAyurvedha}>
                        Explore Ayurvedic Range
                      </button>
                    </div>
                  </Left>
                  <RightUnviel className="unveiling">
                    <div className="visual-card">
                      <div className="visual-glow" />
                      <ImageContainer className="unveiling">
                        <img
                          src="/storage/general/banner1-3.png"
                          alt="Image not found"
                        />
                      </ImageContainer>
                      <div className="visual-card__badge">Pure &amp; Potent</div>
                      <div className="visual-card__note">
                        <span>Hand-picked herbs, freshly crafted</span>
                        <span>Elevate your daily wellness ritual</span>
                      </div>
                    </div>
                  </RightUnviel>
                </ContainerFull>
              </div>
            </Unveiling>
          </div>
        </section>

        {/* Discover section start */}
        <section className="wrapper my-0 md:my-4">
          <div className="mx-auto sm:px-6 max-w-7xl">
            <Discover>
              <div className="wrapper">
                <ContainerFull className="discover">
                  <Left className="discover">
                    <h3>Discover the Soul of Kerala.</h3>
                    <h5>
                      Experience Authentic Crafts, Handlooms & Ayurveda. Immerse
                      yourself in the rich heritage of Kerala.
                    </h5>
                    <p>Subscribe for our blogs...</p>
                    <form onSubmit={handleSubscribe}>
                      <input
                        type="email"
                        placeholder="Enter your email"
                        value={subEmail}
                        onChange={(e) => setSubEmail(e.target.value)}
                      />
                      <button type="submit">Subscribe</button>
                    </form>
                  </Left>
                  <RightDiscover className="discover">
                    <ImageContainer className="discover">
                      <img
                        src="/storage/general/banner1.png"
                        alt="Image not found"
                      />
                    </ImageContainer>
                  </RightDiscover>
                </ContainerFull>
              </div>
            </Discover>
          </div>
        </section>
        {/* Discover section end */}
        {/* ----------------------------------------------------- */}
      </main>
    </>
  );
}
export default HomepageNew;
const Section = styled.section`
  // experience
  &.experience {
    display: grid;

    place-items: center;
    border-right: 1px solid #000;
    margin: 20px 0;
    padding: 20px 0;
    &:last-child {
      border: none;
    }
    h5 {
      margin-top: 15px;
      margin-bottom: 15px;
      font-weight: 600;
      color: rgba(0, 0, 0, 1);
      font-size: 20px;
      font-family: "Poppins", sans-serif;
      @media screen and (max-width: 640px) {
        font-size: 16px;
      }
    }
    @media screen and (max-width: 768px) {
      margin: 0;
      padding: 0;
      border-right: none;
      padding-bottom: 10px;
      border-bottom: 1px solid #000;
      margin: 0 20px;
      &:first-child {
        margin-top: 40px;
        @media screen and (max-width: 640px) {
          margin-top: 25px;
        }
      }
      &:last-child {
        margin-bottom: 40px;
        @media screen and (max-width: 640px) {
          margin-bottom: 20px;
        }
      }
    }
  }
  // deals
  // popular
  // unveiling
  // deals
  // topselling
  // discover
`;
const Container = styled.div`
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 239, 217, 1);
  // experience
  &.experience {
    background-color: #fff;
    border: 1px solid rgba(255, 239, 217, 1);
    border-radius: 32px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 20px;
    color: rgba(0, 0, 0, 1);
    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  // deals
  &.deals {
    display: grid;
    grid-template-columns: 2fr 1fr;
    align-items: start;
  }
  // popular
  // unveiling
  &.unveiling {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 20px;
    align-items: start;
    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  &.discover {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;

    @media screen and (max-width: 980px) {
      grid-template-columns: 1fr;
    }
  }
  // deals
  // topselling
  // discover
`;
const Hero = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  
  .slider-container {
    width: 100%;
    
    @media screen and (max-width: 1024px) {
      max-height: 480px;
    }
    @media screen and (max-width: 768px) {
      max-height: 380px;
    }
    @media screen and (max-width: 480px) {
      max-height: 300px;
    }
  }
`;
const Experience = styled.div`
  position: relative;
  bottom: -20px;

  @media screen and (min-width: 1441px) {
    bottom: -30px;
  }

  @media screen and (max-width: 1280px) {
    bottom: -10px;
  }
  
  @media screen and (max-width: 1024px) {
    bottom: 0px;
  }

  &.top {
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
  &.bottom {
    display: none;
    @media screen and (max-width: 768px) {
      display: block;
    }
  }
`;
const Deals = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 15px;
  padding: 40px;
  border-radius: 40px;
  background: linear-gradient(180deg, #ffefd9 0%, #f4f4f4 100%);
  justfy-content: center;
  @media screen and (max-width: 1400px) {
    grid-template-columns: 2fr 0.7fr;
    justify-items: center;
    row-gap: 60px;
  }
  @media screen and (max-width: 1024px) {
    display: none !important;
  }
`;
const MobileDeals = styled.div`
  display: none !important;
  @media screen and (max-width: 1024px) {
    display: block !important;
    // padding-top: 40px;
    .slick-slide {
      max-width: 240px;
      padding-right: 5px;
    }
  }
`;
const Popular = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr;
  gap: 10px;
  padding-top: 40px;
  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
    justify-items: center;
    row-gap: 60px;
  }
  @media screen and (max-width: 640px) {
    display: none;
  }
`;
const ItalicText = styled.b`
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-style: italic;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0;
  text-align: center;
  display: block;
  color: rgba(0, 0, 0, 1);
`;
const View = styled.button`
  display: grid;
  justify-items: end;
  width: 100%;
  background: none;
  border: none;
  padding-bottom: 30px;
  button {
    background-color: #fc9800;
    color: #fff;
    padding: 10px 20px;
    border: none;
    border-radius: 10px;
    font-weight: 500;
  }
`;
const PopularInner = styled.div`
  padding: 30px 0;
  display: grid;
  grid-template-columns: 1.2fr 2fr;
  gap: 10px;
  padding-top: 40px;
  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
    justify-items: center;
    row-gap: 60px;
  }
  @media screen and (max-width: 640px) {
    display: none;
  }
`;
const Unveiling = styled.div`
  background: linear-gradient(135deg, #123524 0%, #0d261a 100%);
  border: 1px solid rgba(197, 168, 128, 0.15);
  padding: 60px 0;
  position: relative;
  border-radius: 36px;
  box-shadow: 0 20px 40px rgba(18, 53, 36, 0.12);
`;
const TopSelling = styled.div`
  padding: 60px 0;
  padding-bottom: 0;
  h2 {
    font-weight: 500;
    font-size: 24px;
    margin-bottom: 30px;
  }
  .slick-slide {
    padding-right: 5px;
    max-height: 480px;
  }
  .slick-slider {
    max-height: 480px;
  }
  .slider-container {
    max-height: 480px;
  }
`;
const Discover = styled.div`
  background: linear-gradient(135deg, #FDFBF7 0%, #F2ECE1 100%);
  border: 1px solid rgba(197, 168, 128, 0.15);
  padding: 70px 0;
  border-radius: 36px;
  box-shadow: 0 15px 35px rgba(45, 31, 24, 0.02);
`;
const Left = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 15px;
  align-items: flex-start;
  @media screen and (max-width: 1600px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
  &.deals-left {
    // border: 1px solid #ececec;
    // padding: 10px;
    border-radius: 10px;
    height: fit-content;
    align-items: stretch !important;
  }
  &.unveiling {
    gap: 24px;
    grid-template-columns: 1fr;
    align-items: start;
    justify-items: start;
    .badge {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 6px 16px;
      border-radius: 999px;
      background: rgba(197, 168, 128, 0.12);
      border: 1px solid rgba(197, 168, 128, 0.2);
      color: #ffdda4;
      font-size: 13px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.1em;
    }
    h3 {
      font-family: "Playfair Display", serif;
      font-size: 42px;
      font-weight: 700;
      line-height: 1.25;
      color: #fff;
      @media screen and (max-width: 540px) {
        font-family: "Playfair Display", serif;
        font-weight: 700;
        font-size: 28px;
        line-height: 1.3;
      }
    }
    .subcopy {
      font-family: "Jost", sans-serif;
      color: rgba(255, 255, 255, 0.82);
      font-size: 16px;
      line-height: 1.7;
      max-width: 520px;
      @media screen and (max-width: 540px) {
        font-family: "Jost", sans-serif;
        font-weight: 400;
        font-size: 15px;
        text-align: justify;
      }
    }
    .benefits {
      display: grid;
      gap: 14px;
      padding: 0;
      margin: 0;
      list-style: none;
      li {
        display: flex;
        align-items: center;
        gap: 12px;
        font-family: "Jost", sans-serif;
        font-size: 15px;
        color: rgba(255, 255, 255, 0.9);
        font-weight: 500;
        &::before {
          content: "✓";
          color: #C5A880;
          font-weight: 700;
          font-size: 16px;
          margin-right: 4px;
        }
      }
    }
    .cta-group {
      display: flex;
      flex-wrap: wrap;
      gap: 14px;
      align-items: center;
      button {
        background-color: #fc9800;
        color: #fff;
        border: none;
        border-radius: 14px;
        padding: 12px 26px;
        display: inline-flex;
        align-items: center;
        gap: 16px;
        font-size: 16px;
        font-weight: 600;
        box-shadow: 0 12px 24px rgba(252, 152, 0, 0.28);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        svg {
          font-size: 20px;
          color: #fff;
        }
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 14px 32px rgba(252, 152, 0, 0.36);
        }
      }
      .secondary {
        background: transparent;
        border: 1px solid rgba(255, 255, 255, 0.6);
        color: #fff;
        padding: 12px 22px;
        box-shadow: none;
        gap: 10px;
        svg {
          font-size: 18px;
        }
        &:hover {
          background: rgba(255, 255, 255, 0.12);
        }
      }
      @media screen and (max-width: 540px) {
        flex-direction: column;
        align-items: stretch;
        button,
        .secondary {
          width: 100%;
          justify-content: center;
        }
      }
    }
  }
  &.discover {
    grid-template-columns: 1fr;

    h3 {
      font-family: "Playfair Display", serif;
      font-size: 42px;
      font-weight: 700;
      color: #123524;
      margin-bottom: 12px;
      line-height: 1.25;
      @media screen and (max-width: 640px) {
        font-size: 30px;
      }
    }
    h5 {
      font-family: "Jost", sans-serif;
      font-size: 16px;
      font-weight: 400;
      color: #3e190d;
      opacity: 0.85;
      line-height: 1.6;
      margin-bottom: 24px;
    }
    p {
      font-family: "Jost", sans-serif;
      font-weight: 600;
      color: #123524;
      font-size: 14px;
      letter-spacing: 0.05em;
      text-transform: uppercase;
    }
    form {
      display: flex;
      width: 100%;
      max-width: 480px;
      margin-top: 15px;
      box-shadow: 0 8px 24px rgba(18, 53, 36, 0.05);
      border-radius: 50px;
      overflow: hidden;
      border: 1px solid rgba(197, 168, 128, 0.25);
      background: #fff;
      padding: 4px;
      
      input {
        border: none;
        outline: none;
        padding: 12px 20px;
        flex-grow: 1;
        font-family: "Jost", sans-serif;
        font-size: 14px;
        color: #1F1F1F;
        background: transparent;
        &::placeholder {
          color: #C5A880;
          opacity: 0.7;
        }
      }
      button {
        border: none;
        outline: none;
        background: #123524;
        color: #fff;
        font-family: "Jost", sans-serif;
        font-weight: 600;
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        padding: 12px 30px;
        border-radius: 50px;
        cursor: pointer;
        transition: all 0.3s ease;
        
        &:hover {
          background: #C5A880;
        }
      }
    }
  }
`;

const Card = styled.div`
  border: 1px solid rgb(229, 229, 229);
  border-radius: 23px;
  overflow: hidden;
  min-height: 375px;
  max-width: 255px;
  cursor: pointer;
  background-color: #fff;
  p {
    min-height: 35px;
    font-family: Poppins;
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    color: rgba(0, 0, 0, 1);
  }
  &.fullHeight {
    height: 100%;
  }
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.32);
    transform: translateY(-2px);
  }
`;

const CardMobile = styled.div`
  border: 1px solid rgb(229, 229, 229);
  border-radius: 23px;
  overflow: hidden;
  min-height: 267px;
  max-height: 290px;
  min-width: 167px;
  p {
    min-height: 28px;
    font-family: Poppins;
    font-weight: 500;
    font-style: Medium;
    font-size: 10px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    color: rgba(0, 0, 0, 1);
  }
  &.fullHeight {
    height: 100%;
  }
  &:hover {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.32);
  }
`;

const CardTopSelling = styled.div`
  // border: 1px solid rgb(229, 229, 229);
  border-radius: 23px;
  overflow: hidden;
  min-height: 375px;
  max-width: 290px;
  p {
    min-height: 35px;
    font-family: Poppins;
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    color: rgba(0, 0, 0, 1);
  }
  &.fullHeight {
    height: 100%;
  }
`;
const CardRight = styled.div`
  border: 1px solid rgba(250, 152, 1, 1);
  border-radius: 23px;
  overflow: hidden;
  min-height: 375px;
  max-width: 255px;
  background-color: #fff;
  p {
    min-height: 35px;
    font-family: Poppins;
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    color: rgba(0, 0, 0, 1);
  }
  &.fullHeight {
    height: 100%;
  }
  &:hover {
    box-shadow: 0 4px 12px rgba(250, 152, 1, 1);
    transform: translateY(-2px);
  }

  @media (min-width: 800px) {
    min-width: 250px;
  }
`;
const Top = styled.div`
  position: relative;
  background-color: #fff;
  min-height: 150px;
`;
const Bottom = styled.div`
  padding: 10px 20px;
  border-radius: 0 0 10px 8px;

  &.withWhite {
    background-color: #fff;
  }
  &.withbg {
    background-color: #ad4b0e;
    p,
    h3 {
      color: #fff;
      font-size: 22px;
      padding: 10px 0;
      font-weight: 600;
    }
  }
  &.withbg-right {
    background-color: #ad4b0e;
    p,
    h3 {
      color: #fff;
      font-size: 15px;
      padding: 10px 0;
      font-weight: 400;
    }
  }
`;
const BottomMobile = styled.div`
  padding: 10px 10px;
  border-radius: 0 0 10px 8px;

  &.withWhite {
    background-color: #fff;
  }
  &.withbg {
    background-color: #ad4b0e;
    p,
    h3 {
      color: #fff;
      font-size: 10px;
      padding: 10px 0;
      font-weight: 500;
    }
  }
  &.withbg-right {
    background-color: #ad4b0e;
    p,
    h3 {
      color: #fff;
      font-size: 15px;
      padding: 10px 0;
      font-weight: 400;
    }
  }
`;
const CartBtn = styled.div`
  button {
    border: none;
    padding: 10px;
    border-radius: 10px;
    &.green {
      background-color: #389763;
      svg {
        color: #fff;
      }
    }
    background-color: #fff;

    svg {
      color: #ad4b0e;
      font-size: 20px;
    }
  }
`;
const DescriptionButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    font-family: Poppins;
    font-weight: 500;
    font-style: Medium;
    font-size: 24px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0%;
    color: rgba(0, 0, 0, 1);
    min-height: 35px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
`;
const Like = styled.div`
  background-color: transparent;
  padding: 10px;
  position: absolute;
  right: 20px;
  top: 20px;
  border-radius: 10px;
  color: #000;
  svg {
    font-size: 22px;
    fill: rgba(217, 217, 217, 1);
    &:hover {
      color: red;
    }
  }
`;
const CardImageContainer = styled.div`
  // margin-top: 10px;
  height: 200px;
  width: 100%;
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;

    display: block;
  }
  @media screen and (max-width: 420px) {
    height: 150px;
    width: unset;
    img {
      object-fit: contain;
    }
  }
  &.top-selling {
    img {
      object-fit: cover;
    }
    @media screen and (max-width: 420px) {
      height: 210px;
      width: unset;
    }
  }
  &.fullHeight {
    /* height: calc(100% - 170px); */
  }
`;
const CardImageContainerMobile = styled.div`
  // margin-top: 10px;
  height: 120px;
  width: 100%;
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;

    display: block;
  }
  @media screen and (max-width: 420px) {
    height: 150px;
    width: unset;
    img {
      object-fit: contain;
    }
  }
  &.top-selling {
    img {
      object-fit: cover;
    }
    @media screen and (max-width: 420px) {
      height: 120px;
      width: unset;
    }
  }
  &.fullHeight {
    /* height: calc(100% - 170px); */
  }
`;
const Right = styled.div`
  display: grid;
  gap: 15px;
  align-items: start;
  grid-template-columns: 1fr 1fr;
  height: fit-content;
  @media screen and (max-width: 1400px) {
    grid-template-columns: 1fr;
    // max-width: 255px;
  }
  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr;
    // width: 100%;
    // display: -webkit-inline-box;
  }
`;

const RightDiscover = styled.div`
  gap: 15px;
  align-items: start;
  grid-template-columns: 1fr 1fr;
  height: fit-content;
  @media screen and (max-width: 1500px) {
    grid-template-columns: 1fr;
  }
  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr;
    width: 100%;
  }
`;

const MobileHero = styled.div`
  display: none;
  @media screen and (max-width: 540px) {
    display: block;
  }
  .slider-container {
    @media screen and (max-width: 540px) {
      max-height: 540px;
    }
    @media screen and (max-width: 430px) {
      max-height: 200px;
    }
    @media screen and (max-width: 340px) {
      height: 200px;
    }
  }
`;
const Slide = styled.div`
  // hero
  &.hero {
    position: relative;

    button {
      position: absolute;
      bottom: 30%;
      left: 125px;
      @media screen and (max-width: 1024px) {
        left: 88px;
      }
      @media screen and (max-width: 768px) {
        left: 95px;
        bottom: 25%;
      }
      border: none;
      padding: 10px 20px;
      min-width: max-content;
      border-radius: 10px;
      display: flex;
      gap: 20px;
      align-items: center;
      justify-content: center;
      a,
      svg {
        font-size: 18px;
        color: white;
      }
    }
  }
  // experience
  // deals
  // popular
  // unveiling
  // deals
  // topselling
  // discover
`;
const MobileSlide = styled.div`
  // hero
  &.hero {
    position: relative;

    button {
      position: absolute;
      bottom: 20%;
      left: 50%;
      transform: translate(-50%, 50%);
      border: none;
      padding: 5px 10px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      a,
      svg {
        font-size: 18px;
        color: white;
      }
    }
  }
  // experience
  // deals
  // popular
  // unveiling
  // deals
  // topselling
  // discover
`;
const ImageContainer = styled.div`
  // hero
  &.hero {
    height: 630px;
    width: 100%;
    @media screen and (max-width: 1024px) {
      height: 450px;
    }
    @media screen and (max-width: 768px) {
      width: 90%;
      margin: auto;
      height: 305px;
    }
    @media screen and (max-width: 540px) {
      height: 540px;
    }
    @media screen and (max-width: 430px) {
      height: 200px;
    }
    @media screen and (max-width: 340px) {
      height: 200px;
    }
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    @media screen and (max-width: 768px) {
      border-radius: 10px;
    }
  }
  // experience
  &.experience {
    background: #ad4b0e;
    height: 40px;
    width: 40px;
    padding: 7px;
    border-radius: 8px;
  }
  // deals
  // popular
  // unveiling
  &.unveiling-banner {
    position: absolute;
    left: 24px;
    bottom: 24px;
    img {
      height: 180px;
      width: 180px;
      object-fit: cover;
    }
  }
  &.unveiling {
    height: 340px;
    display: grid;
    place-items: center;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
    @media screen and (max-width: 540px) {
      height: 250px;
    }
  }
  // deals
  // topselling
  // discover
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
  padding-bottom: 40px;
  @media screen and (max-width: 540px) {
    padding-bottom: 0px;
  }
`;
const TopSellingButton = styled.button`
  width: 36px;
  height: 36px;
  border: 1px solid rgba(250, 152, 1, 1);
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;

  svg {
    color: rgba(250, 152, 1, 1);
    transition: color 0.3s ease;
    font-size: 20px;
  }

  &:hover {
    background-color: rgba(250, 152, 1, 1);

    svg {
      color: #fff;
    }
  }
`;

const RatingBox = styled.div`
  position: absolute;
  top: 7px;
  left: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 24px;
  border-radius: 4px;
  gap: 2px;
  padding: 0 8px;
  background-color: #C5A880; /* Antique Malabar Gold */
  font-size: 12px;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(18, 53, 36, 0.08);
  z-index: 2;
`;
const LikeBox = styled.div`
  position: absolute;
  top: 7px;
  right: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 24px;
  z-index: 2;
  cursor: pointer;
`;
const OutlinedGreenButton = styled.button`
  width: 100%;
  height: 38px;
  background-color: #ffffff;
  border: 1px solid #123524;
  color: #123524;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 11px;
  border-radius: 30px;
  font-family: "Jost", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);

  &:hover {
    background-color: #123524;
    color: #ffffff;
  }
`;
const OutlinedOrangeButton = styled.button`
  width: 100%;
  height: 38px;
  background-color: #C5A880;
  border: 1px solid #C5A880;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 11px;
  border-radius: 30px;
  font-family: "Jost", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);

  &:hover {
    background-color: #ffffff;
    color: #C5A880;
    border-color: #C5A880;
  }
`;

export const PromoCard = styled.div`
  width: 255px;
  height: 255px;
  background-color: #005c2e;
  border-radius: 8px;
  padding: 20px;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  p {
    font-weight: 500;
    font-size: 18px;
    span {
      color: #f7b500;
    }
  }

  h5 {
    font-size: 14px;
    font-weight: 400;
  }

  button {
    background: white;
    border: none;
    border-radius: 6px;
    color: #005c2e;
    padding: 8px 12px;
    font-size: 14px;
    cursor: pointer;
    margin-top: 10px;
  }
`;

const ContainerFull = styled.div`
  // experience
  &.experience {
    background-color: #fff;
    border: 1px solid rgba(196, 196, 196, 1);
    border-radius: 32px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 20px;
    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  // deals
  &.deals {
    display: grid;
    grid-template-columns: 2fr 1fr;
    align-items: start;
  }
  // popular
  // unveiling
  &.unveiling {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 20px;
    align-items: start;
    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  &.discover {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;

    @media screen and (max-width: 980px) {
      grid-template-columns: 1fr;
    }
  }
  // deals
  // topselling
  // discover
`;

const RightUnviel = styled.div`
  gap: 15px;
  align-items: start;
  grid-template-columns: 1fr 1fr;
  height: fit-content;
  display: flex;
  justify-content: center;
  @media screen and (max-width: 1500px) {
    grid-template-columns: 1fr;
  }
  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr;
    width: 100%;
  }
  &.unveiling {
    width: 100%;
    .visual-card {
      position: relative;
      width: min(360px, 100%);
      padding: 30px 28px 36px;
      border-radius: 28px;
      background: linear-gradient(162deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%);
      border: 1px solid rgba(255, 255, 255, 0.18);
      backdrop-filter: blur(12px);
      display: grid;
      gap: 18px;
      justify-items: center;
      overflow: hidden;
    }
    .visual-glow {
      position: absolute;
      inset: -40% -20%;
      background: radial-gradient(circle at center, rgba(252, 152, 0, 0.35) 0%, rgba(8, 76, 39, 0.05) 70%);
      filter: blur(40px);
      z-index: 0;
    }
    .visual-card > * {
      position: relative;
      z-index: 1;
    }
    .visual-card__badge {
      padding: 6px 18px;
      border-radius: 999px;
      background: rgba(8, 76, 39, 0.85);
      color: #ffdda4;
      font-weight: 600;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      font-size: 12px;
    }
    .visual-card__note {
      display: grid;
      gap: 6px;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.84);
      text-align: center;
      span:first-child {
        font-weight: 600;
      }
    }
    @media screen and (max-width: 540px) {
      .visual-card {
        width: 100%;
        padding: 26px 22px 32px;
      }
      .visual-card__note {
        font-size: 13px;
      }
    }
  }
`;

const PopularMain = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 1.5fr;
  gap: 30px;

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const DealsIntroCard = styled.div`
  transition: none !important;
  transform: none !important;

  &:hover {
    transform: none !important;
    transition: none !important;
  }
`;
